export const Columns = (t) => {
	const base = [
		{
			headerName: 'ID',
			field: 'id',
			width: 80,
			cellRenderer: (params) => (
				<span className="text-muted" style={{ fontSize: '0.8rem' }}>#{params.value}</span>
			)
		},
		{
			headerName: 'name',
			field: 'name',
			width: 300,
			filter: true
		},
		{
			headerName: 'periodicity',
			field: 'periodicity',
			width: 180,
			filter: true,
			// Pacote em dias mostra a duração: "Mensal" seria enganoso, porque a periodicidade
			// não vale para ele.
			cellRenderer: (params) => {
				const days = Number(params.data?.packageDays) || 0;
				if (days > 0) {
					return `${days} ${days === 1 ? 'dia' : 'dias'}`;
				}
				return params.value ? t(String(params.value).toLowerCase()) : '-';
			}
		},
		{
			headerName: 'qty_transactions',
			field: 'qtyTransactions',
			width: 180,
			// Plano sem limite de ciclos vem com qtyTransactions nulo e a coluna ficava em
			// branco, sem dizer se era ausência de dado ou cobrança sem fim. O aviso é
			// desta coluna, não da periodicidade: mensal é mensal com ou sem limite. Mesmo
			// rótulo usado no detalhe do plano (PlanDetails).
			// Pacote em dias não tem ciclos de cobrança, então "Indeterminado" também seria enganoso.
			cellRenderer: (params) => {
				if (Number(params.data?.packageDays) > 0) {
					return '-';
				}
				return Number(params.value) > 0 ? params.value : t('indeterminate');
			}
		},
		{
			headerName: 'price',
			field: 'price',
			type: 'currency',
			width: 100
		},
		{
			headerName: 'plan_subscribers',
			field: 'openSubscriptionCount',
			width: 130,
			// Assinaturas não canceladas no plano, inclusive depois de ele ser desativado: quem já
			// assina continua no plano, e é por aqui que se vê quantos ficaram nele.
			cellRenderer: (params) => Number(params.value || 0)
		}
	];

base.push({
		headerName: 'status',
		field: 'status',
		type: 'trans'
	});

	return base;
}
